import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUpdateUserSettings } from "#root/queries/users";
import { ROUTES } from '#root/routes/constants';
import { Avatar, Button, Field, Input } from "@fluentui/react-components";
import "./styles.scss";
import { showToast } from '#root/components/GlobalToaster';
import { useCurrentUser } from '#root/queries/local';
import { Breadcrumbs } from '#root/components/Breadcrumbs';
import { loadCurrentUser } from '#root/redux/auth/actions';
import { useDispatch } from 'react-redux';

interface UserSettingsForm {
    firstName?: string;
    lastName?: string;
    email: string;
    phoneNumber?: string;
}

const UserSettings: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const updateUser = useUpdateUserSettings();

    const { data: currentUser } = useCurrentUser();

    const [userSettingsForm, setUserSettingsForm] = useState<UserSettingsForm>({
        firstName: currentUser?.firstName || '',
        lastName: currentUser?.lastName || '',
        email: currentUser?.email || '',
        phoneNumber: currentUser?.phoneNumber || ''
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await updateUser.mutateAsync({
                userSettings : userSettingsForm
            });

            dispatch(loadCurrentUser());
            showToast('User settings updated successfully', 'success');
            handleCancel();
        }
        catch {
            showToast('Failed to update user settings', 'error');
        }
    };

    const handleCancel = () => {
        if (window.history.state?.idx > 0) {
            navigate(-1);
        } else {
            navigate(ROUTES.ROOT);
        }
    };

    return (
        <div className="user-settings">
            <div className="emc-page-header">
                <div className="emc-page-header__top-row">
                    <div className="emc-page-header__breadcrumbs">
                        <Breadcrumbs />
                    </div>
                </div>
                <div className="emc-page-header__title">
                    <h2>User Settings <div className="divider"></div></h2>
                </div>
            </div>
            <Avatar size={96} className="user-avatar" name={currentUser?.firstName + ' ' + currentUser?.lastName || currentUser?.email} />
            <form onSubmit={handleSubmit} className="form-section">
                <div className="field-two-columns">
                    <Field label="First Name">
                        <Input value={userSettingsForm.firstName} onChange={(e) => setUserSettingsForm({ ...userSettingsForm, firstName: e.target.value })} />
                    </Field>
                    <Field label="Last Name">
                        <Input value={userSettingsForm.lastName} onChange={(e) => setUserSettingsForm({ ...userSettingsForm, lastName: e.target.value })} />
                    </Field>
                </div>
                <div className="field-two-columns">
                    <Field label="Email" required>
                        <Input value={userSettingsForm.email} onChange={(e) => setUserSettingsForm({ ...userSettingsForm, email: e.target.value })} />
                    </Field>
                    <Field label="Phone Number">
                        <Input value={userSettingsForm.phoneNumber} onChange={(e) => setUserSettingsForm({ ...userSettingsForm, phoneNumber: e.target.value })} />
                    </Field>
                </div>


                <div className="form-actions">
                    <Button
                        type="submit"
                        appearance="primary"
                        size="large"
                        disabled={updateUser.isPending}
                    >
                        {updateUser.isPending ? 'Saving...' : 'Save'}
                    </Button>
                    <Button appearance="secondary" size="large" onClick={handleCancel}>
                        Cancel
                    </Button>
                </div>
            </form>
        </div>
    );
}

export default UserSettings;
